import { render, staticRenderFns } from "./afflist.vue?vue&type=template&id=79e4e970"
import script from "./afflist.vue?vue&type=script&lang=js"
export * from "./afflist.vue?vue&type=script&lang=js"
import style0 from "./afflist.vue?vue&type=style&index=0&id=79e4e970&prod&lang=scss&scooped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports